import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  AttendancePolicyData,
  CommonReducerAction,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import viewMetaData from "./ViewMetaData";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

let viewModeElement = [];
const generateElement = (objElement, values, viewData) => {
  let dependentval;
  let displayVal;
  let subHeaderVal;
  // Check if Dynamic Value is an array
  if (Array.isArray(values)) {
    if (objElement.dependent != undefined && objElement.dependent != "") {
      dependentval = `#${viewData[objElement.dependent]}`;

      values.forEach((val) => {
        if (val[dependentval] != undefined) {
          displayVal = val[dependentval];
        }
      });
    }
  } else {
    displayVal = values;
  }

  // /Check If static subheader is an array
  if (Array.isArray(objElement.subheader)) {
    if (objElement.dependent != undefined && objElement.dependent != "") {
      dependentval = `#${viewData[objElement.dependent]}`;

      objElement.subheader.forEach((val) => {
        if (val[dependentval] != undefined) {
          subHeaderVal = val[dependentval];
        }
      });
    }
  } else {
    subHeaderVal = objElement.subheader;
  }

  return (
    <div>
      <p className={objElement.headercss}>{objElement.header}</p>
      <p className={objElement.subheadercss}>{subHeaderVal}</p>
      <p style={{ textAlign: "justify" }}>{displayVal}</p>
    </div>
  );
};

function generateData(metaObj, viewData) {
  let dynamicVal = "";
  let jsonVal = "";
  let isValidobj = true;
  if (viewData != undefined) {
    Object.keys(viewData).forEach((result) => {
      isValidobj = true;
      if (viewData[result] != null) {
        if (Array.isArray(viewData[result])) {
          // if(metaObj[result] !=undefined)
          generateData(metaObj, viewData[result]);
        } else if (typeof viewData[result] === "object") {
          // if(metaObj[result] !=undefined)

          generateData(metaObj, viewData[result]);
        } else if (
          typeof viewData[result] === "string" ||
          typeof viewData[result] === "boolean" ||
          typeof viewData[result] === "number"
        ) {
          if (metaObj[result] != undefined) {
            if (Array.isArray(metaObj[result])) {
              if (metaObj[result][0][viewData[result]] != undefined) {
                if (isValidobj) {
                  const nested = generateElement(
                    metaObj[result][0][viewData[result]],
                    metaObj[result][0][viewData[result]].values,
                    viewData,
                  );
                  viewModeElement.push(nested);
                }
              }
            } else if (typeof metaObj[result] === "object") {
              if (typeof viewData[result] === "boolean") {
                dynamicVal = viewData[result] ? "Yes" : "No";
                if (dynamicVal == "No") {
                  isValidobj = false;
                }
              } else {
                dynamicVal = viewData[result];
                if (
                  dynamicVal == null ||
                  dynamicVal == "0" ||
                  dynamicVal == 0 ||
                  dynamicVal == "" ||
                  dynamicVal == "00:00:00" ||
                  dynamicVal == "00:00"
                ) {
                  isValidobj = false;
                }
              }
              jsonVal = metaObj[result].values;
              jsonVal = jsonVal.replace("<val>", dynamicVal);

              if (isValidobj) {
                const nested = generateElement(
                  metaObj[result],
                  jsonVal,
                  viewData,
                );
                viewModeElement.push(nested);
              }
            }
          }
        }
      }
      return viewModeElement;
    });

    return viewModeElement;
  }
}

class Preview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      InitAttendancePolicy: {},
      Metadata: {},
      elementList: [],
    };
  }

  componentDidMount() {
    const { InitAttendancePolicy } = this.props;
    this.props.onRef({
      onNext: this.validateNext,
    });
    const viewmodejson = viewMetaData;
    viewModeElement = [];
    const elementArray = generateData(viewmodejson, InitAttendancePolicy);
    this.setState({
      InitAttendancePolicy,
      Metadata: viewmodejson,
      elementList: elementArray,
    });
  }

  render() {
    const language = this.props.Language.extratime;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="padding-30 ">
          <div className="inner-wrapper opaque">{this.state.elementList}</div>
        </div>
      </IntlProvider>
    );
  }
}

Preview.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitAttendancePolicy: state.InitAttendancePolicy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendancePolicyData: (data) => AttendancePolicyData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Preview)));
